import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogbookSummaryService } from './logbook-summary.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [LogbookSummaryService],
})
export class LogbookSummaryModule {}
